import clsx from 'clsx';
import { forwardRef } from 'react';

import { DataTestId } from '../../../core/types/data-props.js';
import { StylingProps } from '../../../core/types/styling-props.js';
import { WithChildren } from '../../../core/types/with-children.js';
import { Flex } from '../../../layouts/flex/Flex.js';
import { actionsSlotCss } from '../EmptyState.sty.js';

//#region Typings
/**
 * @public
 */
export interface EmptyStateActionsProps
  extends WithChildren,
    StylingProps,
    DataTestId {}
//#endregion Typings

/**
 * The actions slot of the EmptyState component.
 * @public
 */
export const Actions = /* @__PURE__ */ forwardRef<
  HTMLDivElement,
  EmptyStateActionsProps
>((props, forwardedRef) => {
  const {
    children,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
  } = props;

  return (
    <Flex
      ref={forwardedRef}
      flexDirection="row"
      alignItems="center"
      gap={8}
      className={clsx([actionsSlotCss, consumerClassName])}
      style={consumerStyle}
      data-testid={dataTestId}
    >
      {children}
    </Flex>
  );
});

(Actions as typeof Actions & { displayName: string }).displayName =
  'EmptyState.Actions';
